import React, {Component} from 'react';
import Styles from './style.css';
import cx from "classnames";
const queryString = require('query-string');

class TemplateCarouselBasicFirst extends Component {

    constructor(props) {
        super(props);
        this.state = {
            industry: "",
            location: "",
            price: "",
            error: false
        };
    };

    componentWillMount() {
        try {
            let url = window.location.search;
            let data = queryString.parse(url);
            this.setState({
                industry: data.industry,
                location: data.location,
                price: data.price
            })
        }catch (e) {
            this.setState({
                error: true
            });
        }
    }

    render() {
        return(
            <div className={Styles.container}>
                <div className={cx(Styles.First)}>
                    <div className={Styles.FirstInnerOverlay}>
                        <div className={Styles.FirstInnerOverlayTitle}>
                            {this.state.industry}
                        </div>
                        <div className={Styles.FirstInnerOverlaySubtitle}>
                            {this.state.location}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default TemplateCarouselBasicFirst;


// WEBPACK FOOTER //
// ./src/templates/carousel/basic/first/component.js